"use client";

import { createWorkspaceToolStore } from "@/components/workspace-shell/workspace-tool-store";
import {
  ChartLine,
  MessageSquare,
  PanelTopBottomDashed,
  Users,
  type LucideIcon,
} from "lucide-react";

export type AnalyticsToolId = "pages" | "overview" | "audience" | "feedback";

export const ANALYTICS_TOOLS: readonly {
  id: AnalyticsToolId;
  label: string;
  icon: LucideIcon;
}[] = [
  { id: "pages", label: "Pages", icon: PanelTopBottomDashed },
  { id: "overview", label: "Handyout overview", icon: ChartLine },
  { id: "audience", label: "Audience", icon: Users },
  { id: "feedback", label: "Feedback", icon: MessageSquare },
];

const store = createWorkspaceToolStore<AnalyticsToolId>();

export const getAnalyticsTool = store.get;
export const setAnalyticsTool = store.set;
export const toggleAnalyticsTool = store.toggle;
export const useAnalyticsTool = store.useTool;
